/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unexpected-multiline */
/* eslint-disable comma-dangle */

export default {
  init() {
    // JavaScript to be fired on all pages

    $('#fullpage').fullpage({
        hybrid: true,
        fitToSection: false,
        normalScrollElementTouchThreshold: 3,
        responsiveWidth: '1440'
    });

    /*
    $('.text-line').each(function () {
        var characters = $(this).text().split("");
        var $this = $(this);
        $this.empty();
        $.each(characters, function (i, el) {
        $this.append("<span class='animated-letter slowly-appear'>" + el + "</span");
        });
    });
    */

    // Mobile Menu
    $('.nav-toggle').click(function(){
      $('.hamburger-menu .bar').toggleClass('animate');
      $('body').toggleClass('nav-open');
    });

    // Inview Functions
    function inView( opt ) {
        if( opt.selector === undefined ) {
            console.log( 'Valid selector required for inView' );
            return false;
        }
        var elems = [].slice.call( document.querySelectorAll( opt.selector ) ),
            once = opt.once === undefined ? true : opt.once,
            offsetTop = opt.offsetTop === undefined ? 0 : opt.offsetTop,
            offsetBot = opt.offsetBot === undefined ? 0 : opt.offsetBot,
            count = elems.length,
            winHeight = 0,
            ticking = false;
        function update() {
            var i = count;
            while( i-- ) {
                var elem = elems[ i ],
                    rect = elem.getBoundingClientRect();
                if( rect.bottom >= offsetTop && rect.top <= winHeight - offsetBot ) {
                    elem.classList.add( 'in-view' );
                    if( once ) {
                        count--;
                        elems.splice( i, 1 );
                    }
                } else {
                    elem.classList.remove( 'in-view' );
                }
            }
            ticking = false;
        }
        function onResize() {
            winHeight = window.innerHeight;
            requestTick();
        }
        function onScroll() {
            requestTick();
        }
        function requestTick() {
            if( !ticking ) {
                requestAnimationFrame( update );
                ticking = true;
            }
        }
        window.addEventListener( 'resize', onResize, false );
        document.addEventListener( 'scroll', onScroll, false );
        document.addEventListener( 'touchmove', onScroll, false );
        onResize();
    }
    // InView
    inView({
        selector: '.inview-item', // an .in-view class will get toggled on these elements
        once: true, // set this to false to have the .in-view class be toggled on AND off
        offsetTop: 0, // top threshold to be considered "in view"
        offsetBot: 200, // bottom threshold to be considered "in view"
    });

    $('.faux-login').submit(function (e) {
      e.preventDefault();
      $('.error_msg').fadeIn();
    });

    $('#login').on('shown.bs.modal', function () {
      $('.error_msg').hide();
    })


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js